/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Activity_Drag_Must_Complete_FirstInputs */

const vi_work_activity_drag_must_complete_first = /** @type {(inputs: Work_Activity_Drag_Must_Complete_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhiệm vụ phải được đánh dấu hoàn thành trước khi đóng.`)
};

/**

* @param {Work_Activity_Drag_Must_Complete_FirstInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const work_activity_drag_must_complete_first = /** @type {((inputs?: Work_Activity_Drag_Must_Complete_FirstInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Activity_Drag_Must_Complete_FirstInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_work_activity_drag_must_complete_first(inputs)
});